export const defaultData = {
  email_address: "",
  membership_level: "",
  date_of_birth: "",
  event_id: "",

  // The membership end date, unless they have cancelled this should be their renewal date.
  MembershipEndDate: "",
  // The date of the very first membership purchase.
  MembershipStartDate: "",
  // The date the customer registered their account with us.
  RegistrationDate: "",
  // Total amount of orders placed by this member.
  TotalOrders: "",
  // Item types in an order placed in a session ( Product Only / Membership Only / Product + Membership / "")
  order_basket_type: "",
}
